<template>
  <div class="rechargePay">
    <div class="operate">
      <div class="title">
        账户充值
      </div>
      <a-row class="basicInfo">
        <a-col :span="4" align="center" style="margin-right:40px;">
          <div class="memberImg">
            <a-avatar :size="64" icon="user" :src="avatar()" />
          </div>
          <div class="memberLines">
            <a-row>
              <a-col :span="12" align="right">
                昵称：
              </a-col>
              <a-col :span="12" align="left">
                &nbsp;&nbsp;&nbsp;&nbsp;{{ userInfo().nickName }}
              </a-col>
            </a-row>
          </div>
          <div class="memberLines">
            <a-row>
              <a-col :span="12" align="right">
                手机号：
              </a-col>
              <a-col :span="12" align="left">
                &nbsp;&nbsp;&nbsp;&nbsp;{{ userInfo().mobile }}
              </a-col>
            </a-row>
          </div>
          <div class="memberLines">
            <a-row>
              <a-col :span="12" align="right">
                账户(用户名)：
              </a-col>
              <a-col :span="12" align="left">
                &nbsp;&nbsp;&nbsp;&nbsp;{{ userInfo().userName }}
              </a-col>
            </a-row>
          </div>
          <div class="memberLines">
            <a-row>
              <a-col :span="12" align="right">
                账户余额：
              </a-col>
              <a-col :span="12" align="left">
                &nbsp;&nbsp;&nbsp;&nbsp;{{ userInfo().balance }}
              </a-col>
            </a-row>
          </div>
        </a-col>
        <a-col :span="18">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" tab="线上充值">
              <div v-if="isSuccess" class="pay-success">
                <a-result status="success" title="充值成功">
                  <template #extra>
                    <a-button @click="keepTrying">
                      继续支付
                    </a-button>
                  </template>
                </a-result>
              </div>
              <div v-else>
                <a-form
                  :form="form"
                  :label-col="{ span: 4 }"
                  :wrapper-col="{ span: 12 }"
                >
                  <a-form-item style="margin-bottom:0;" label="充值方式">
                    <div>线上扫码支付</div>
                  </a-form-item>
                  <a-form-item label="选择支付方式" style="margin-bottom:0;">
                    <a-radio-group
                      v-decorator="[
                        'type',
                        {
                          initialValue: 1,
                          rules: [
                            {
                              required: true,
                              message: '请选择支付方式'
                            }
                          ]
                        }
                      ]"
                    >
                      <a-radio :value="1">
                        支付宝
                      </a-radio>
                      <a-radio :value="2">
                        微信
                      </a-radio>
                    </a-radio-group>
                  </a-form-item>

                  <a-form-item style="margin-bottom:0;" label="充值金额">
                    <a-input-number
                      v-decorator="[
                        'pay',
                        {
                          initialValue: 100,
                          rules: [
                            {
                              required: true,
                              message: '请填写充值金额'
                            },
                            {
                              validator: (rule, value, callback) => {
                                if (value < 0) {
                                  callback('抱歉金额不能为负');
                                }
                                if (value > 10000) {
                                  callback('抱歉金额超过10000');
                                }
                                if (
                                  value &&
                                  !/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(
                                    value
                                  )
                                ) {
                                  callback('至多支持两位小数');
                                }
                                callback();
                              }
                            }
                          ]
                        }
                      ]"
                      size="small"
                      :min="1"
                      :max="10000"
                      :step="100"
                      @change="handleChange"
                    />
                  </a-form-item>
                  <a-form-item style="margin-bottom:0;" label="扣除手续费">
                    <div style="color:red">{{ handlingFees }}元</div>
                  </a-form-item>
                  <a-form-item
                    style="margin-bottom:0;color:red"
                    label="实际到账金额"
                  >
                    <div>{{ amount }}元</div>
                  </a-form-item>
                  <a-form-item
                    style="margin-bottom:0;"
                    :wrapper-col="{ offset: 3 }"
                  >
                    <a-button :loading="confirmLoading" @click="handleSubmit">
                      确认充值
                    </a-button>
                  </a-form-item>
                </a-form>
              </div>
            </a-tab-pane>
            <a-tab-pane key="2" tab="线下充值" force-render>
              <div>线下充值请联系对应的客户经理索取我司账户进行汇款、转账</div>
              <div>
                并将充值结果告知客户经理，我司财务核实到账后将为您账户增加余额
              </div>
            </a-tab-pane>
          </a-tabs>
        </a-col>
      </a-row>
    </div>
    <div class="tips">
      <div class="title">
        充值常见问题
      </div>
      <div class="tips-content">
        <div class="item-title">
          1. 手续费怎么收？
        </div>
        <div>
          答：手续费是由支付宝进行收取的，费率为0.6%每笔。您进行支付，实际到账的金额需扣除掉0.6%的手续费。
        </div>
        <div class="item-title">
          2. 账户充值金额用在何处，充值后可以提现吗？
        </div>
        <div>
          答：充值的金额用于您管理的用户使用猫先生APP进行线上提现。充值后金额原则上不支持提现；
        </div>
        <div class="item-title">
          3. 线上扫码支付为什么无法成功充值？
        </div>
        <div>
          答：通过支付宝线上扫码充值，会受到充值额度的限制，建议您分批进行充值，每次充值金额不超过10000元；
        </div>
        <div class="item-title">
          4. 线上充值成功了，为什么账户余额没有增加？
        </div>
        <div>
          答：充值金额是实时到账的，可到账户充值中查询充值记录，若没有查到记录可能是系统延时引起的，请您稍后再查询。若超过一天仍未显示，请与客户经理联系处理；
        </div>
        <div class="item-title">
          5. 线下充值了，为什么账户余额还未增加？
        </div>
        <div>
          答：线下充值需要人工处理需一定的时效，一般在您反馈充值成功后两个工作日内核实是否到账并增加余额，如长时间账户余额未增加请联系客户经理处理。
        </div>
      </div>
    </div>
    <div class="btn-list">
      <a-button type="primary" @click="handleGoBack">
        返回
      </a-button>
    </div>
    <div id="aliPay"></div>
    <div ref="qrCodeUrl" class="qrcode"></div>
    <a-modal
      v-model="visible"
      centered
      :title="null"
      :footer="null"
      destroy-on-close
      :mask-closable="false"
      width="320px"
      @cancel="cancel"
    >
      <div class="ecode">
        <div ref="qrCodeUrl" class="qrcode" style="margin-top: 20px;"></div>
        <div class="txtcode">
          请扫码进行微信支付
        </div>
      </div>
      <!-- <div class="download">
        <a-button
          type="primary"
          class="mr8"
          @click="downLoad(modelData.giftname)"
        >
          下载
        </a-button>
      </div> -->
    </a-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { recharge, wxRecharge } from "@/api/finance";
import QRCode from "qrcodejs2";
import mqtt from "mqtt";
import { MQTT_SERVICE, MQTT_USERNAME, MQTT_PASSWORD } from "@/config/mqtt.js";
export default {
  data() {
    return {
      pay: 100,
      loaded: false,
      isSuccess: false,
      confirmLoading: false,
      form: this.$form.createForm(this, { name: "submitForm" }),
      visible: false,
      mqttConfig: {
        username: MQTT_USERNAME,
        password: MQTT_PASSWORD
      },
      mqttNew: {}
    };
  },
  computed: {
    handlingFees() {
      return Math.round(this.pay * 0.006 * 100) / 100;
    },
    amount() {
      return this.pay - Math.round(this.pay * 0.006 * 100) / 100;
    }
  },
  mounted: function() {
    this.handleQuery();
  },
  methods: {
    ...mapGetters(["avatar", "userInfo"]),
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log(values);
          this.confirmLoading = true;
          if (values.type == 1) {
            const params = {
              menuId: "adfedc8730954de6ac2fc55b9c06738e",
              amount: values.pay
            };
            recharge(params)
              .then(res => {
                const result = res.result;
                // console.log(result, "result");
                const index = result.indexOf("<s");
                const payHtml = result.slice(0, index);
                this.handleDom(payHtml);
                this.$nextTick(() => {
                  const form = document.punchout_form;
                  // console.log(form);
                  this.confirmLoading = false;
                  form.submit();
                });
              })
              .catch(err => {
                console.log(err);
                this.confirmLoading = false;
              });
          } else {
            const params = {
              menuId: "adfedc8730954de6ac2fc55b9c06738e",
              amount: values.pay
            };
            wxRecharge(params)
              .then(res => {
                // const result = res.result;
                this.mqttNew = res.result;
                this.initMQTT(res.result.topic);
                this.visible = true;
                this.$nextTick(() => {
                  var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                    text: res.result.url,
                    width: 200,
                    height: 200,
                    colorDark: "#000000",
                    colorLight: "#ffffff"
                    // correctLevel: QRCode.CorrectLevel.L
                  });
                });
                // console.log(result, "result");
                // const index = result.indexOf("<s");
                // const payHtml = result.slice(0, index);
                // this.handleDom(payHtml);
                // this.$nextTick(() => {
                //   const form = document.punchout_form;
                //   console.log(form);
                //   this.confirmLoading = false;
                //   form.submit();
                // });
              })
              .catch(err => {
                console.log(err);
                this.confirmLoading = false;
              });
          }
        }
      });
    },
    cancel() {
      this.confirmLoading = false;
    },
    handleChange(value) {
      this.pay = value;
    },
    handleDom(value) {
      const payHtml = document.getElementById("aliPay");
      const div = document.createElement("div");
      payHtml.innerHTML = "";
      div.innerHTML = value;
      payHtml.appendChild(div);
    },
    handleGoBack() {
      this.$router.push("/finance/account/recharge");
    },
    handleQuery() {
      const { total_amount } = this.$route.query;
      if (total_amount) {
        this.isSuccess = true;
      }
    },
    keepTrying() {
      this.isSuccess = false;
      // this.$router.push({ query: {} }); // 删除页面参数
      this.$router.push("/finance/account/rechargePay");
    },
    initMQTT(val) {
      const client = mqtt.connect(MQTT_SERVICE, this.mqttConfig);
      // MQTT链接
      client.on("connect", e => {
        client.subscribe(val, { qos: 1 }, error => {
          console.log(val);

          if (error) {
            console.log(error, "订阅失败");
          } else {
            console.log("MQTT订阅成功");
          }
        });
      });
      // 接收消息处理
      client.on("message", (topic, message) => {
        this.visible = false;
        const msg = JSON.parse(message);
        // console.log(msg, "msg");

        if (msg.state == 2) {
          this.isSuccess = true;

          // this.$message.success("微信充值成功");
        } else {
          this.$message.success("微信充值失败");
        }

        // const list = msg.userIds
        // if (list.includes(userId)) {
        //   console.log(`收到来自${topic}的消息`)
        //   func && func(msg)
        // }
      });
      // 断开发起重连
      client.on("reconnect", () => {
        console.log("正在重连");
      });
      // 链接异常处理
      client.on("error", error => {
        console.log(error, "连接失败");
      });
    }
  }
};
</script>
<style scoped>
.ant-modal {
  width: 280px;
}
.txtcode {
  margin-top: 20px;
  text-align: center;
  font-size: 18px;
}
.ecode {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
<style lang="stylus">
.rechargePay
  .ant-result
    padding 0
  .ant-result-extra
    margin-top 10px
</style>
<style lang="stylus" scoped>
.rechargePay
  width 100%
  background-color #fff
  padding 16px 20px
  margin-bottom 20px
  font-size 12px
  .basicInfo
    margin 16px 0
    .memberImg
      width 100px
      text-align center
      margin-bottom 10px
    .memberLines
      height 32px
      line-height 32px
  .operate
    height 320px
  .tips
    width 100%
    margin-top 146px
    .tips-content
      margin-top 10px
      .item-title
        font-size 14px
        color #000
        margin-bottom 8px
        margin-top 4px
  .btn-list
      width 100%
      text-align center
      margin-top 60px
      margin-bottom 20px
</style>
